import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor, ButtonGroupPosition } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';

@Component({
  template: `
    <fl-bit class="HeaderSection" flTrackingSection="TaskWelcomeModal">
      <fl-heading
        i18n="Task welcome modal title"
        [size]="HeadingSize.SMALL"
        [headingType]="HeadingType.H1"
        [flMarginBottom]="Margin.SMALL"
      >
        <ng-container *ngIf="!viewAsFreelancer">
          Welcome to your project Tasks
        </ng-container>
        <ng-container *ngIf="viewAsFreelancer">
          Welcome to project Tasks
        </ng-container>
      </fl-heading>
    </fl-bit>
    <fl-bit class="BodySection">
        <fl-text
          i18n="Task modal message"
          [flMarginBottom]="Margin.MID"
        >
          <ng-container *ngIf="!viewAsFreelancer">
            Here you can collaboratively keep track of all the tasks that need to be completed as part of your project.
            Any tasks you create will be visible to any freelancers you award, and both of you will be able to edit
            the list at any time.
          </ng-container>
          <ng-container *ngIf="viewAsFreelancer">
            Here you can collaboratively keep track of all the tasks that need to be completed as part of the project.
            Any tasks you create will be visible to the employer and any other awarded freelancers, and any of you will
            be able to edit the list at any time.
          </ng-container>
        </fl-text>
      </fl-bit>
    <fl-bit>
      <fl-button
        i18n="Task modal button"
        flTrackingLabel="TaskWelcomeModalClose"
        [color]="ButtonColor.SECONDARY"
        (click)="handleClose()"
      >
        OK
      </fl-button>
    </fl-bit>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['task-welcome-modal.component.scss'],
})
export class TaskWelcomeModalComponent {
  ButtonColor = ButtonColor;
  ButtonGroupPosition = ButtonGroupPosition;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  Margin = Margin;

  @Input() viewAsFreelancer: false;

  constructor(private modalRef: ModalRef<TaskWelcomeModalComponent>) {}

  handleClose() {
    this.modalRef.close();
  }
}
